import fetchClient from '@/api/api-client'

export async function listAffiliateUsers() {
  try {
    const res = await fetchClient.get('/affiliatePage')
    return res.data.data.response
  } catch (error) {
    // console.log("listAffiliateUsers - error", error)
    throw error
  }
}

export async function createRef(data) {
  try {
    const payload = {
      data,
    }

    const res = await fetchClient.post('/affiliate', payload)
    // console.log("createRef - res", res)
    return res.data
  } catch (err) {
    // console.log("createRef - err", err)
    throw err
  }
}

export async function updateRef(refUserId, data) {
  try {
    const payload = {
      data,
    }

    const res = await fetchClient.patch(`/affiliate/${refUserId}`, payload)
    // console.log("updateRef - res", res)
    return res.data
  } catch (err) {
    // console.log("updateRef - err", err)
    throw err
  }
}

export async function getRef(refNum) {
  try {
    const res = await fetchClient.get(`affiliate/${refNum}`)
    // console.log("getRef - res", res)

    return res.data.data.response
  } catch (err) {
    // console.log("getRef - err", err)
    throw err
  }
}

export async function getRefById(refUserId) {
  try {
    const res = await fetchClient.get(`/affiliate/refId/${refUserId}`)
    // console.log("getRefById - res", res)
    return res.data
  } catch (err) {
    // console.log("getRefById - err", err)
    throw err
  }
}

export async function deleteRefUser(refUserId) {
  try {
    const res = await fetchClient.delete(`/affiliate/${refUserId}`)
    // console.log("deleteRefUser - res", res)
    return res.data
  } catch (err) {
    // console.log("deleteRefUser - err", err)
    throw err
  }
}

export async function sendEmailAffReq(data) {
  const payload = { data }
  try {
    const res = await fetchClient.post(`/sendEmail`, payload)
    // console.log("getRefById - res", res)
    return res.data
  } catch (err) {
    // console.log("getRefById - err", err)
    throw err
  }
}
